/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getUserBoardNavigationResources,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { userBoardVelocityRoute } from '@jira/router-routes__classic-projects-routes/src/userBoardVelocityRoute.tsx';
import VelocityPage, {
	LazyNextGenVelocityReport,
} from '@jira/router-routes__next-gen-entries/src/ui/software/reports/velocity/index-old.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const userBoardVelocityRouteEntry: Route = createEntry(userBoardVelocityRoute, () => ({
	group: 'classic-software',
	ufoName: 'software-reports.velocity-report-cmp',
	// eslint-disable-next-line no-restricted-syntax
	component: VelocityPage,
	layout: genericProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
	},

	resources: [...getNavigationResources(), ...getUserBoardNavigationResources()],
	forPaint: [LazyAtlassianNavigation, LazyNextGenVelocityReport],
	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
